<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts">
// import { useAuthSiteStore } from '../../../../user/authSiteStore.ts'

// export const useOnboardingLoader = defineBasicLoader('/(app)/[org]/onboarding/onboarding', {
//   async load({ params }) {
//     const org = (params as { org?: string }).org
//     if (!org) {
//       throw new Error('Missing org param for onboarding loader')
//     }
//   },
// })

// export const useResumeStep = defineBasicLoader(async (to) => {
//     console.log('step index to', to)
//     // const context = useAuthSiteStore().currentContext
//     // if (!context?.site) {
//     //     throw new Error('Missing site context for onboarding loader')
//     // }

//     const org = (to.params as { org?: string }).org
//     if (!org) {
//       throw new Error('Missing org param for onboarding loader')
//     }

//     const step = useOnboardingStore().resumeStepId
//     reroute({ name: '/(app)/[org]/onboarding/[stepId]', params: { org, stepId: step } })
// })
</script>

<script setup lang="ts">
definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        onboardingEntry: true,
        featureFlags: 'onboarding',
    }
})

// useResumeStep()
</script>

<template>
    <div>Never Renders...</div>
</template>